import { render, staticRenderFns } from "./MEM_utilization_top10.vue?vue&type=template&id=77aeb840"
import script from "./MEM_utilization_top10.vue?vue&type=script&lang=js"
export * from "./MEM_utilization_top10.vue?vue&type=script&lang=js"
import style0 from "./MEM_utilization_top10.vue?vue&type=style&index=0&id=77aeb840&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports